module.exports = "/_next/static/images/Tim-1872982f8da7f3749b12e767e429fdb0.jpg";